// @flow
import { compose } from 'redux'

import StaticTextPage from '../src/staticTextPage/StaticTextPage'
import withAuthentication from '../src/withAuthentication'
import { PUBLIC, permissions } from '../src/routes'

export default compose(withAuthentication(permissions[PUBLIC]))(StaticTextPage)
